module.exports = __webpack_public_path__ + "static/favicon-84ae6231e9a9e96f2da8b7d5d9886447.ico";